import { Flex, RadioGroup } from '@chakra-ui/react'
import type { PaymentTypes } from 'commons/constants/paymentTypes'
import { BgColors, TextColors } from 'commons/design-system/tokens'
import type { PropsWithChildren } from 'react'

type Props = PropsWithChildren<{ value: PaymentTypes }>

export const PaymentTypeButton = ({ children, value }: Props) => {
	return (
		<RadioGroup.Item
			value={value}
			w='full'
			cursor='pointer'
			rounded='xl'
			p={5}
			gap={3}
			bg={BgColors.Z5}
			color={TextColors.PRIMARY}
			transition='0.22s ease-out background-color'
			_hover={{ bg: BgColors.Z4 }}
			_focus={{
				outline: '2px solid',
				outlineColor: BgColors.OPPOSITE_Z3,
				outlineOffset: '-2px'
			}}
			_checked={{
				bg: `${BgColors.STATUS_INFO} !important`
			}}
		>
			<RadioGroup.ItemHiddenInput />
			<RadioGroup.ItemControl
				bg='transparent'
				borderStyle='solid'
				borderWidth='2px'
				borderColor={TextColors.OPPOSITE_TERTIARY}
				boxSize='20px'
				_checked={{
					borderColor: BgColors.OPPOSITE_Z3,
					bg: BgColors.OPPOSITE_Z3,
					boxShadow: 'inset 0 0 0 3px white'
				}}
			/>
			<Flex
				fontFamily='Montserrat'
				fontSize={{ base: '13px', sm: '16px' }}
				fontWeight='600'
				gap={2}
				alignItems='center'
			>
				{children}
			</Flex>
		</RadioGroup.Item>
	)
}
